export const uuidRequiredError = "ID обязательно к заполнению"
export const uuidLengthCount = 36

export const titleRequiredError = "Название обязательно"
export const titleLengthMinCount = 2
export const titleLengthMinError = "Минимум 2 символа"
export const titleLengthMaxCount = 255
export const titleLengthMaxError = "Максимум 255 символов"

export const firstNameLengthMaxError = "Имя должно быть до 30 символов"
export const firstNameLengthMaxCount = 30
export const lastNameLengthMaxError = "Фамилия должна быть до 30 символов"
export const lastNameLengthMaxCount = 30
export const patronymicLengthMaxError = "Отчество должно быть до 30 символов"
export const patronymicLengthMaxCount = 30

export const usernameRequiredError = "Имя пользователя обязательно к заполнению"
export const usernameLengthMinCount = 2
export const usernameLengthMinError =
  "Имя пользователя должно быть больше 2-ух символов"
export const usernameLengthMaxCount = 255
export const usernameLengthMaxError =
  "Имя пользователя должно быть меньше 255-ти символов"

export const passwordRequiredError = "Пароль обязательный к заполнению"
export const passwordLengthMinCount = 8
export const passwordLengthMinError = "Пароль должно быть от 8-ти символов"
export const passwordLengthMaxCount = 100
export const passwordLengthMaxError = "Пароль должно быть меньше 100 символов"

export const enterpriseTitleRequiredError = "Название обязательно"
export const enterpriseTitleLengthMinCount = 2
export const enterpriseTitleLengthMinError = "Минимум 2 символа"
export const enterpriseTitleLengthMaxCount = 255
export const enterpriseTitleLengthMaxError = "Максимум 255 символов"

export const shopTitleRequiredError = "Название обязательно"
export const shopTitleLengthMinCount = 2
export const shopTitleLengthMinError = "Минимум 2 символа"
export const shopTitleLengthMaxCount = 255
export const shopTitleLengthMaxError = "Максимум 255 символов"

export const itemTitleRequiredError = "Название обязательно"
export const itemTitleLengthMinCount = 2
export const itemTitleLengthMinError = "Минимум 2 символа"
export const itemTitleLengthMaxCount = 255
export const itemTitleLengthMaxError = "Максимум 255 символов"

export const itemCountRequiredError = "Количество обязательно"
export const itemCountMinCount = 0
export const itemCountMinError = "Минимум 0"

export const itemTypeOfCountRequiredError = "Тип учёта обязателен"
export const itemTypeOfCountAllowError =
  "Необходимо выбрать правильный тип учёта"
export const itemTypeOfCountWeight = "WEIGHT"
export const itemTypeOfCountCount = "COUNT"

export const itemNumberRequiredError = "Поле обязательно"
export const itemNumberMinCount = 0
export const itemNumberMinError = "Минимум 0"

export const orderSumRequiredError = "Сумма обязательна"
export const orderSumMinCount = 0
export const orderSumMinError = "Минимум 0"

export const orderTypeOrderAdd = "ADD"
export const orderTypeOrderRemove = "REMOVE"

export const orderSourceTypeShops = "SHOPS"
export const orderSourceTypeItems = "ITEMS"
export const orderSourceTypeUsers = "USERS"
export const orderSourceTypeSales = "SALES"
export const orderSourceTypeOthers = "OTHERS"
export const orderSourceTypeShopSalePoints = "SHOP_SALE_POINTS"
export const orderSourceTypeShopPaymentPoints = "SHOP_PAYMENT_POINTS"

export const shopPaymentPointTypeOfPaymentCash = "CASH"
export const shopPaymentPointTypeOfPaymentCard = "CARD"
export const shopPaymentPointTypeOfPaymentQr = "QR"

export const shopPaymentPointTypeOfPaymentRequiredError =
  "Тип оплаты обязателен"
export const shopPaymentPointTypeOfPaymentAllowError =
  "Необходимо выбрать правильный тип оплаты"

export const saleFromDateRequiredError = "Начальная дата обязательна"
export const saleFromDateMinCount = 0
export const saleFromDateMinError = "Минимум 0"

export const saleToDateRequiredError = "Конечная дата обязательна"
export const saleToDateMinCount = 0
export const saleToDateMinError = "Минимум 0"
